module.exports = __webpack_public_path__ + "img/downimg_bg03.486fe72d.png";